// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "braboconcursos.firebaseapp.com",
  "projectId": "braboconcursos",
  "storageBucket": "braboconcursos.appspot.com",
  "messagingSenderId": "388196158600",
  "appId": "1:388196158600:web:50ecca42e45c06a461233d",
  "measurementId": "G-G9SR00HPLS",
  "apiKey": "AIzaSyDBFNaKzaHY0SrDzXsZpMDErEizMalugp8"
};
